import { useState } from "react";
import { Form } from "react-bootstrap";
import { Notyf } from "notyf";

function ProductActiveToggle({ product, setProducts }) {
  const notyf = new Notyf();
  const [status, setStatus] = useState(product?.isActive || false);

  const handleToggle = (isActive) => {
    //  fetch Request to Update Product Status
    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/products/${product._id}/${
        isActive === true ? "archive" : "activate"
      }`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ isActive: !status }),
      }
    )
      .then((response) => {
        if (!response.ok) {
          notyf.error("Failed to update product status");
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then(() => {
        // Update Front-end
        setStatus(!status);
        setProducts((prevProducts) =>
          prevProducts.map((prod) =>
            prod._id === product._id ? { ...prod, isActive: !status } : prod
          )
        );
        // Handle successful toggle
        notyf.success("Product status updated successfully");
      })
      .catch((error) => {
        notyf.error("Error updating product status");
        console.error("Error updating product status:", error);
      });
  };

  return (
    <Form.Check
      type="switch"
      id="active-switch"
      style={{ float: "right", marginLeft: "10px" }}
      name="status"
      checked={status}
      onChange={() => handleToggle(status)}
    />
  );
}

export default ProductActiveToggle;
